import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BillingFormComponent } from './billing-form/billing-form.component';
import { ErrorComponent } from './error/error.component';
import { PaymentFormComponent } from './payment-form/payment-form.component';
import { PaymentReceiptComponent } from './payment-receipt/payment-receipt.component';
import { PaymentReviewComponent } from './payment-review/payment-review.component';
import { SuccessComponent } from './success/success.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'billing',
    pathMatch: 'full'
  },
  {
    path: 'billing',
    component: BillingFormComponent
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: 'payment',
    component: PaymentFormComponent
  },
  {
    path: 'review',
    component: PaymentReviewComponent
  },
  {
    path: 'receipt',
    component: PaymentReceiptComponent
  },
  {
    path: 'success',
    component: SuccessComponent
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
